// extracted by mini-css-extract-plugin
export default {"container":"QuestionItem_container__rvIit","title":"QuestionItem_title__194JM"};